/** @format */

import React, { PureComponent } from 'react';
import I18n from '../../../components/Translate/I18n';
import { Typography } from '@material-ui/core';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { BlockContainHelper, GetContainViewProps, StatusField } from '../../../modules/block/BlockContainHelper';
import { SleepTimeElement } from '../SleepTimeElement';
import TableHead from '@material-ui/core/TableHead';
import { ErrorElement } from '../ErrorElement';
import { CallFunctionElement } from '../CallFunctionElement';
import { DefinitionHeaderElement } from '../DefinitionHeaderElement';

class GetStatusView extends PureComponent<GetContainViewProps> {
    private blockHelper = new BlockContainHelper();

    render(): React.ReactNode {
        const { element, functions } = this.props;

        const functionName = 'prov:f.' + element.mvnoBlockFunction.displayName.trim().toLowerCase();
        const params = this.blockHelper.explodeParams(element);

        let keyId = 0;

        return (
            <Card>
                <CardHeader>
                    <Typography variant="subtitle1">
                        <I18n trans={functionName} />
                    </Typography>
                </CardHeader>
                <CardBody xs={12}>
                    <SleepTimeElement seconds={element.sleepSeconds} />
                    <Table>
                        <TableHead>
                            <DefinitionHeaderElement />
                        </TableHead>
                        <TableBody>
                            {params.status &&
                                typeof params.status === 'object' &&
                                params.status.map((statusField: StatusField) => {
                                    keyId++;
                                    return (
                                        <CallFunctionElement
                                            key={'element' + keyId}
                                            name={statusField.value}
                                            value={this.blockHelper.getFunctionNameById(parseInt(statusField.call), functions)}
                                        />
                                    );
                                })}
                            {params.callNext && (
                                <TableRow>
                                    <TableCell padding="none" align="left">
                                        2
                                    </TableCell>
                                    <TableCell padding="none" align="right">
                                        <I18n trans={this.blockHelper.getFunctionNameById(parseInt(params.callNext), functions)} />
                                    </TableCell>
                                </TableRow>
                            )}
                            <ErrorElement name={this.blockHelper.getFunctionNameById(7, functions)} />
                        </TableBody>
                    </Table>
                </CardBody>
            </Card>
        );
    }
}

export default compose<any, any>(withStyles(adescomStyle))(GetStatusView);
